(() => {
  function showCookieSettingsWhenAvailable() {
    if (typeof window.privacyBanner?.showPreferences !== 'function') return;

    document.querySelectorAll('[data-amy-cookie-preferences]').forEach((button) => {
      if (button.dataset.amyCookieReady) return;
      button.dataset.amyCookieReady = 'true';
      button.hidden = false;
      button.addEventListener('click', () => window.privacyBanner.showPreferences());
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showCookieSettingsWhenAvailable, { once: true });
  } else {
    showCookieSettingsWhenAvailable();
  }
  window.addEventListener('load', showCookieSettingsWhenAvailable, { once: true });
  document.addEventListener('shopify:section:load', showCookieSettingsWhenAvailable);
})();
